import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import { useAtomValue } from 'jotai';

import {
    GLOBAL_NAV_MOBILE_BREAKPOINT,
    appBarHeightDesktop,
    appBarHeightMobile,
    closedNavDrawerWidthDesktop,
    closedNavDrawerWidthMobile,
    isGlobalDrawerOpenAtom,
    openNavDrawerWidth,
} from './constants';

// Custom hook specifically for GlobalNavigationDrawer - accepts a maxWidth breakpoint
export const useIsGlobalNavMobile = (maxWidth: number = GLOBAL_NAV_MOBILE_BREAKPOINT): boolean => {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down(maxWidth), { noSsr: true });
};

export const useGlobalReservedAppBarHeight = () =>
    useIsGlobalNavMobile() ? appBarHeightMobile : appBarHeightDesktop;

export const useGlobalReservedNavDrawerWidth = (): string => {
    const isMobile = useIsGlobalNavMobile();
    const isDrawerOpen = useAtomValue(isGlobalDrawerOpenAtom);

    if (isMobile) return closedNavDrawerWidthMobile;

    if (isDrawerOpen) return openNavDrawerWidth;

    return closedNavDrawerWidthDesktop;
};
